// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_qDl","toggleWrap":"styles_toggleWrap__2rJI3","content":"styles_content__2jHq_","selectAreaCode":"styles_selectAreaCode__15cyw"};